import React from 'react';

import PDFViewer from './PDFViewer';
import {extract, getAttachmentUrl, toAttachment, toPixel, toStyleString } from "../../utils";
import _ from 'lodash'
import {Image} from 'primereact/image'
export type CellAttachment = Attachment

type AttachmentViewerProp = {
  env:string;
  attachment: CellAttachment;
  thumbnail?: boolean;
  fullscreen?: boolean;
  width?:string|number
  height?: string|number
  extraConfig?: any;
};

const AttachmentViewer: React.FC<AttachmentViewerProp> = ({ env, attachment, thumbnail = false,fullscreen = false,width=undefined, height = undefined, extraConfig = {} }) => {
  console.log('AttachmentViewer 1', attachment)
  if (!attachment) {
    return (
      <div className="flex justify-content-center align-items-start">
        <p>There is no data to show.</p>
      </div>
    );
  }
  if(_.isString(attachment)){
    if(attachment.startsWith('http')){
      attachment = toAttachment(attachment)
    }else{
      return (
          <div className="flex justify-content-center align-items-start">
            <p>Invalid URL.</p>
          </div>
      )
    }
  }
  const { type, ext} = attachment;
  const fullUrl = getAttachmentUrl(attachment, ['url'])
  const imgUrl = getAttachmentUrl(attachment, [(thumbnail ?  'thumbnails.small.url' : 'thumbnails.large.url'), 'thumbnails.full.url', 'url'])
  const useHeight = toPixel( thumbnail ? 30 : height, '250px')
  const useWidth = toPixel( thumbnail ? '100%' : width, undefined )
  console.log('AttachmentViewer 2', attachment, height, imgUrl, fullUrl)
  if (thumbnail || type?.startsWith('image/') || ['jpg','jpeg','png','gif'].includes(ext)) {
    return (
      <div className="flex justify-content-center align-items-center" style={{ maxHeight: '100%', minHeight: 0, overflow: 'auto' }}>
        <div className="flex justify-content-center align-items-start">
          <Image alt="" src={imgUrl} imageStyle={ ( thumbnail ? {maxWidth: '100px',maxHeight: '100px', overflow:'hidden'} : { maxWidth: '100%', maxHeight: '100%', height: useHeight , width: useWidth}) as any} {...extract({
             preview: false
          }, extraConfig)} />
          {/*<img alt="" src={url} style={{ maxWidth: '100%', maxHeight: '100%', height: useHeight }} />*/}
        </div>
      </div>
    );
  }
  const style = fullscreen
      ? { width: `calc(100vw - 80px)`, height: `calc(100vh - 140px)` }
      : { flex: 'auto', width: '100%', height: useHeight };

  if (type === 'application/pdf') {
    return <PDFViewer url={fullUrl} fullscreen={fullscreen} height={useHeight}/>;
  }
  if(type?.startsWith('video/')){
    return (
        <video style={{...style, opacity: 1}} controls><source src={fullUrl} type={type.includes('quicktime') ? '': type}/></video>
    )
  }
  if(type?.startsWith('audio/')){
    return (
        <audio style={{...style, height: '100px', opacity: 1}} controls><source src={fullUrl} type={type}/></audio>
    )
  }
  let encoded = encodeURIComponent(fullUrl)
  let src = `https://drive.google.com/viewer?url=${encoded}&embedded=true`;
  if(type?.includes('officedocument')){
    src = `https://view.officeapps.live.com/op/embed.aspx?src=${encoded}`
  }
  return (
    <iframe
      title="attachmentViewer"
      style={style}
      src={src}

      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};

export default AttachmentViewer;
